<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-14 shadow-xl max-w-3xl w-full mx-4 max-h-[90vh] overflow-y-auto borderWhite">
      <!-- Header -->
      <div class="flex justify-between items-center p-6 border-b-2 border-gray">
        <div class="flex items-center">
          <div 
            class="w-3 h-3 rounded-full mr-3"
          />
          <h2 class="Title">
            {{ getHeaderTitle() }}
          </h2>
        </div>
        <button 
          @click="closePopup" 
          class="text-gray-400 hover:text-gray-600 transition-colors"
        >
          <svg
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      
      <!-- Content -->
      <div class="p-6">
        <!-- Statut de la demande -->
        <div class="mb-6">
          <!-- Pour les demandes rejetées -->
          <div 
            v-if="item.dgiStatus === 'REJECTED'"
            class="rounded-12 p-4  rejectBg"
          >
            <div class="flex items-start">
              <div class="w-full text-c15">
                <p class="text-center">
                  <span class="NameStat">Statut :</span> 
                  <span class="reject">{{ getStatusText(item.dgiStatus) }}</span> 
                </p>
                <p class="text-red-700 mt-1">
                  <strong>Motif du rejet :</strong> {{ item.dgiBody.message || 'La demande n\'a pas pu être traitée selon les critères requis.' }}
                </p>
              </div>
            </div>
          </div>
          
          <!-- Pour les demandes approuvées -->
          <div 
            v-else-if="item.dgiStatus === 'APPROVED'"
            class="bg-green-50 border border-green-200 p-4 borderWhite"
          >
            <div class="flex items-start">
              <div class="w-full">
                <p class="text-center">
                  <span class="NameStat">Statut :</span> 
                  <span class="approved">{{ getStatusText(item.dgiStatus) }}</span> 
                </p>
                <p class="text-green-700 mt-1">
                  Votre demande a été approuvée avec succès.
                </p>
                <div
                  v-if="item.dgiNim"
                  class="mt-3 p-3 bg-green-100 rounded"
                >
                  <strong>Token NIM :</strong> {{ item.dgiNim }}
                </div>
              </div>
            </div>
          </div>
          
          <!-- Pour les demandes en attente -->
          <div 
            v-else-if="item.dgiStatus === 'PENDING'"
            class="bg-yellow-50 border border-yellow-200 rounded-lg p-4 borderWhite"
          >
            <div class="flex items-start">
              <div class="w-full">
                <p class="text-center">
                  <span class="NameStat">Statut :</span> 
                  <span class="pending">{{ getStatusText(item.dgiStatus) }}</span> 
                </p>
                <p class="text-yellow-700 mt-1">
                  Votre demande est actuellement en cours de traitement.
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- Informations de l'entreprise -->
        <div class="bg-info p-4 rounded-12">
          <h3 class="text-lg font-medium text-gray-900 mb-4 text-left infotext px-4">
            Informations de l'entreprise
          </h3>
          <div class="bg-gray-50 rounded-lg p-4 space-y-3 max-h-80 overflow-y-auto">
            <div class="flex justify-between">
              <span class="Name">Nom complet :</span>
              <span class="text-gray-900">{{ item.fullName || '---' }}</span>
            </div>
            <div class="">
              <div class="flex justify-between">
                <span class="Name">Demandeur :</span>
                <span class="text-gray-900">{{ item.body.applicant || '---' }}</span>
              </div>
            </div>
            <div class="flex justify-between">
              <span class="Name">IFU :</span>
              <span class="text-gray-900">{{ item.body.ifu || '---' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="Name">Adresse :</span>
              <span class="text-gray-900">{{ item.body.address || '---' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="Name">Adresse1 :</span>
              <span class="text-gray-900">{{ item.body.address1 || '---' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="Name">Adresse2 :</span>
              <span class="text-gray-900">{{ item.body.address2 || '---' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="Name">Ville :</span>
              <span class="text-gray-900">{{ item.body.city || '---' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="Name">Commune :</span>
              <span class="text-gray-900">{{ item.body.commune || '---' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="Name">Points de vente :</span>
              <span class="text-gray-900">{{ item.body.pos || '---' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="Name">Pays :</span>
              <span class="text-gray-900">{{ item.body.posContry || '---' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="Name">Développeur de points de vente :</span>
              <span class="text-gray-900">{{ item.body.posDeveloper || '---' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="Name">Modèle de point de vente :</span>
              <span class="text-gray-900">{{ item.body.posModel || '---' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="Name">Fournisseur de points de vente :</span>
              <span class="text-gray-900">{{ item.body.posSupplier || '---' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="Name">Mail du fournisseur de points de vente :</span>
              <span class="text-gray-900">{{ item.body.posSupplierEmail || '---' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="Name">Numéro du fournisseur de points de vente :</span>
              <span class="text-gray-900">{{ item.body.posSupplierPhone || '---' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="Name"> Activité première :</span>
              <span class="text-gray-900">{{ item.body.primActivity || '---' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="Name"> Activité secondaire :</span>
              <span class="text-gray-900">{{ item.body.secActivity || '---' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="Name">Titre :</span>
              <span class="text-gray-900">{{ item.body.title || '---' }}</span>
            </div>
            <!-- <div class="flex justify-between">
              <span class="Name">Téléphone :</span>
              <span class="text-gray-900">{{ item.body.contact1 || '---' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="Name">Date de demande :</span>
              <span class="text-gray-900">{{ formatDate(item.createdAt) }}</span>
            </div>
            <div class="flex justify-between">
              <span class="Name">Dernière mise à jour :</span>
              <span class="text-gray-900">{{ formatDate(item.updatedAt) }}</span>
            </div>
            <div class="flex justify-between">
              <span class="Name">Mail :</span>
              <span class="text-gray-900">{{ item.body.contact2 || '---' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="Name">Ifu :</span>
              <span class="text-gray-900">{{ item.body.ifu || '---' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="Name">Categorie :</span>
              <span class="text-gray-900">{{ item.categorie || '---' }}</span>
            </div> -->
          </div>
        </div>
      </div>
      <!-- Footer -->
      <div class="flex justify-end gap-3 p-6 rounded">
        <button 
          @click="closePopup"
          class="px-14 py-2 border border-gray-300 rounded-b-2xl text-white font-c8 text-c17 transition-colors close"
        >
          Fermer
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailsPopup',
  
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  
  emits: ['close-popup'],
  
  data() {
    return {};
  },
  
  methods: {
    closePopup() {
      this.$emit('close-popup');
    },
    
    formatDate(dateString) {
      if (!dateString) return 'Non spécifié';
      return new Date(dateString).toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    
    getStatusText(status) {
      const statusMap = {
        'REJECTED': 'Demande rejetée',
        'PENDING': 'En cours de traitement',
        'APPROVED': 'Demande approuvée'
      };
      return statusMap[status] || status;
    },
    
    getHeaderTitle() {
      const titleMap = {
        'REJECTED': 'Demande Rejetée',
        'PENDING': 'Demande en Cours',
        'APPROVED': 'Demande Approuvée'
      };
      return titleMap[this.item.dgiStatus] || 'Détails de la Demande';
    }
  }
}
</script>

<style scoped>
/* Animation d'entrée pour le popup */
.fixed {
  animation: fadeIn 0.3s ease-out;
}

.bg-info{
  background-color: #F6F7FA;
}

.bg-white {
  animation: slideIn 0.3s ease-out;
}

.infotext{
  color: #969FAB;
  font-size: 16px;
  font-weight: 400;
}

.close {
  border-radius: 10px;
  background-color: #F04C36;
  color: #fff;
}

.borderWhite {
  border-radius: 10px;
}

.Title {
  font-size: 20px;
  font-weight: 700;
}

.Name {
  font-size: 16px;
  font-weight: 400;
  color: #6B6B75;
}

.NameStat {
  font-weight: 800;
}

.reject {
  color: #F04C36;
  font-weight: 700;
}

.rejectBg{
  background-color: #FDE4E3;
}

.approved {
  color: green;
  font-weight: 700;
}

.pending {
  color: #f59e0b;
  font-weight: 700;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
HI41DEVS@24